"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;
var _constants = require("./constants");
/**
  * Calculate the component's offset relative to the window.
  *
  * @param {Node|ReactElement} ref Reference to a DOM Node or React Element.
  * @returns {Object} left and top offsets.
  * @public
  */
function offset(ref) {
  const rect = ref.getBoundingClientRect();
  return {
    left: rect.left + _constants.target.pageXOffset - _constants.target.document.documentElement.clientLeft,
    top: rect.top + _constants.target.pageYOffset - _constants.target.document.documentElement.clientTop
  };
}